import { isCoordinateLocation } from '../realtime/contracts';
import type { LocationSource, CoordinateLocation, Location } from '../realtime/contracts';

export type IncidentLocationMapProjection = {
  selectedSource: LocationSource | null;
  selectedCurrentLocation: CoordinateLocation | null;
  selectedTrack: CoordinateLocation[];
  contextualLastLocations: CoordinateLocation[];
};

export function projectIncidentLocationsForMap(
  currentLocation: Location | null,
  selectedTrack: readonly Location[],
  lastLocationsBySource: readonly Location[],
): IncidentLocationMapProjection {
  const selectedSource = currentLocation?.source ?? selectedTrack[0]?.source ?? null;

  return {
    selectedSource,
    selectedCurrentLocation: currentLocation !== null && isCoordinateLocation(currentLocation) ? currentLocation : null,
    selectedTrack: selectedTrack.filter(isCoordinateLocation),
    contextualLastLocations: lastLocationsBySource.filter(
      (location): location is CoordinateLocation =>
        location.source !== selectedSource && isCoordinateLocation(location),
    ),
  };
}
